// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2YIQH","card":"styles_card__1Z4RJ","label":"styles_label__15JNr","button":"styles_button__2INA8"};